import { readAdminSession } from "./adminRepository";

export type HealthStatus = "healthy" | "warning" | "critical";

export type HealthCheck = {
  id: string;
  label: string;
  status: HealthStatus;
  summary: string;
  detail?: string;
};

export type SystemHealthSnapshot = {
  status: HealthStatus;
  generatedAt: string;
  adminEmail: string;
  checks: HealthCheck[];
};

const SYSTEM_HEALTH_ENDPOINT =
  "https://cnejticdknokawqlslsj.supabase.co/functions/v1/system-health";

export async function loadSystemHealth(): Promise<SystemHealthSnapshot> {
  const session = await readAdminSession();
  if (!session) throw new Error("Die Anmeldung ist abgelaufen. Bitte erneut anmelden.");

  const response = await fetch(SYSTEM_HEALTH_ENDPOINT, {
    headers: { Authorization: `Bearer ${session.access_token}` },
  });
  const payload = (await response.json().catch(() => ({}))) as SystemHealthSnapshot & {
    error?: string;
  };

  if (!response.ok) {
    if (payload.error === "authentication_required") {
      throw new Error("Die Anmeldung ist abgelaufen. Bitte erneut anmelden.");
    }
    throw new Error("Der Systemcheck konnte gerade nicht ausgeführt werden.");
  }

  return payload;
}
